import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { NegotiationOption, OutDebt } from '../generated/graphql';
import { getNegBooleans } from './getNegBooleans';

export const getPaymentLinkMovistarMoney = (
  outDebt: OutDebt,
  gT: (key: string, context?: DictionaryContextType) => string,
  negOption?: NegotiationOption,
) => {
  const { extra } = outDebt;
  const { isCatchUp } = getNegBooleans(outDebt, negOption);
  if (isCatchUp) return gT('payment_link_apex_invoice');
  if (extra?.movistarInvoice === 'Si') return gT('payment_link_movistar_invoice');
  return gT('payment_link_apex_invoice');
};
